export default __webpack_public_path__ + "static/media/onboardingBg.80550128.png";